import React from "react";

import FullScreenAuthLoader from "@/ui/organisms/FullScreenAuthLoader";

export type ViewAuthGuardParams = {
    useState: () => {
        isLoading: boolean;
        isAuthenticated: boolean;
        error: unknown;
    };
    useCases: () => {
        onMount: (path: string) => void;
    };
};

export const createViewAuthGuard = ({
    useState,
    useCases,
}: ViewAuthGuardParams) => {
    const ViewAuthGuard: React.FC<{
        component: React.ComponentType;
    }> = ({ component: Component }) => {
        const { isAuthenticated, isLoading, error } = useState();
        const { onMount } = useCases();

        const isAlreadyMountedRef = React.useRef(false);
        React.useEffect(() => {
            if (isAlreadyMountedRef.current) return;

            isAlreadyMountedRef.current = true;
            onMount(`${window.location.pathname}${window.location.search}`);
        }, [onMount]);

        if (isLoading) {
            return <FullScreenAuthLoader label={"Authenticating..."} />;
        }

        if (!isAuthenticated) {
            return <FullScreenAuthLoader label={"Redirecting..."} />;
        }

        if (error !== undefined && error !== null) {
            throw error;
        }

        return (
            <div id="logged-in-main">
                <Component />
            </div>
        );
    };

    return ViewAuthGuard;
};
